import { Button } from "@mui/material";

const PrimaryButton = ({ children, sx = {}, ...rest }) => {
    return (
        <Button
            {...rest}
            variant="contained"
            size="small"
            sx={{
                backgroundColor: "#1434a4",
                color: "#fcfcfc !important",
                borderRadius: "10px",
                fontWeight: "700",
                "&:hover": {
                    backgroundColor: "#1434a4",
                    opacity: 0.8,
                },
                ...sx,
            }}
        >
            {children}
        </Button>
    );
};

export default PrimaryButton;
